import { Route } from '@/app/router'

const PartCategoryGroups = () => import('./index.vue')

const PartCategoryGroupsProps = ['page', 'perPage']

export default new Route('/part-category-groups/:rootId?/:childId?', PartCategoryGroups)
	.as('Dashboard:PartCategoryGroups')
	.props(PartCategoryGroupsProps)
	.permissions(['CREATE_CATEGORY_SET'])
